const formatDate = (
    date: Date | null,
    locale: string,
    options: Intl.DateTimeFormatOptions = {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit"
    },
    format: "date" | "time" = 'date'
) => {
    if (date === null) return '';

    if (format === 'time') {
        return new Intl.DateTimeFormat(locale, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    }

    return new Intl.DateTimeFormat(locale, options).format(date);
};

const randomDate = (start: Date, end: Date) => {
    return new Date(start.getTime() + Math.random() *
        (end.getTime() - start.getTime()));
};

export {formatDate, randomDate};